module.exports = __webpack_public_path__ + "static/img/village2.d56983c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/village2.png
// module id = DxU7
// module chunks = 52